export default function ({app, error}) {
  if (!app.$hasPermission('accept_document')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}